import React, { FC } from "react";
import PropTypes from "prop-types";

import CloseBtn from "../assets/close_btn.png";
import { useGlobalContext } from "./ScanViewerContext";

import styles from "./closeButton.module.scss";

type Props = {
  onCloseBtn: () => void;
  closeButton?: React.ReactNode;
};

const CloseButton: FC<Props> = ({ onCloseBtn, closeButton }) => {
  const { isMobileOnLandscape } = useGlobalContext();
  return (
    <div
      data-cy="closeBtn"
      onClick={onCloseBtn}
      className={`${styles.closeBtn} ${
        isMobileOnLandscape && styles.closeBtnLandscape
      }`}
      aria-label="Close"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onCloseBtn();
        }
      }}
    >
      {closeButton ? (
        closeButton
      ) : (
        <img src={CloseBtn} alt="Close button" draggable={false} />
      )}
    </div>
  );
};

CloseButton.propTypes = {
  onCloseBtn: PropTypes.func.isRequired,
  closeButton: PropTypes.node as PropTypes.Validator<React.ReactNode>,
};

export default CloseButton;
